import React from 'react'
import Text from '@component/Text/Text'

export const TermsAndConditionsEnglish = () => {
    return (
        <>
            <div className={'text-body1 text-gray02 dark:text-dark_gray02 px-[30px]'}>
                <Text className={'text-h2 text-gray01 dark:text-dark_gray01'}>TERMS &amp; CONDITIONS</Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>INTRODUCTION</Text>
                <Text className={'mt-[10px]'}>
                    These terms and conditions (&quot;Terms&quot;, &quot;Agreement&quot;) are an agreement between the
                    Wizpace LTD ( &quot;us&quot;, &quot;we&quot; or &quot;our&quot;) and you (&quot;User&quot;,
                    &quot;you&quot; or &quot;your&quot;). This Agreement sets forth the general terms and conditions of
                    your use of the League of Traders mobile application and any of its products or services
                    (collectively, &quot;Mobile Application&quot; or &quot;Service(s)&quot;).
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 1 - ACCOUNTS AND MEMBERSHIP
                </Text>
                <Text className={'mt-[10px]'}>
                    By using League of Traders, you represent that you are at least the age of majority in your state or
                    province of residence; or that you are the age of majority in your state or province of residence
                    and you have given us your consent to allow any of your minor dependents to use this Mobile
                    Application. If you create an account in the Mobile Application, you are responsible for maintaining
                    the security of your account and you are fully responsible for all activities that occur under the
                    account and any other actions taken in connection with it. We may, but have no obligation to,
                    monitor and review new accounts before you may sign in and use our Services. You must immediately
                    notify us of any unauthorized uses of your account or any other breaches of security. We will not be
                    liable for any acts or omissions by you, including any damages of any kind incurred as a result of
                    such acts or omissions. We may suspend, disable, or delete your account (or any part thereof) if we
                    determine that you have violated any provision of this Agreement or that your conduct or content
                    would tend to damage our reputation and goodwill. If we delete your account for the foregoing
                    reasons, you may not re-register for our Services. We may block your email address and Internet
                    protocol address to prevent further registration.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>SECTION 2 - USER CONTENT</Text>
                <Text className={'mt-[10px]'}>
                    We do not own any data, information or material (&quot;Content&quot;) that you submit in the Mobile
                    Application in the course of using the Service. You shall have sole responsibility for the accuracy,
                    quality, integrity, legality, reliability, appropriateness, and intellectual property ownership or
                    right to use of all submitted Content. We may, but have no obligation to, monitor and review Content
                    in the Mobile Application submitted or created using our Services by you. Unless specifically
                    permitted by you, your use of the Mobile Application does not grant us the license to use,
                    reproduce, adapt, modify, publish or distribute the Content created by you or stored in your user
                    account for commercial, marketing or any similar purpose. But you grant us permission to access,
                    copy, distribute, store, transmit, reformat, display and perform the Content of your user account
                    solely as required for the purpose of providing the Services to you. Without limiting any of those
                    representations or warranties, we have the right, though not the obligation, to, in our own sole
                    discretion, refuse or remove any Content that, in our reasonable opinion, violates any of our
                    policies or is in any way harmful or objectionable.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>SECTION 3 - BACKUPS</Text>
                <Text className={'mt-[10px]'}>
                    We perform regular backups of the data, however, these backups are for our own administrative
                    purposes only and are in no way guaranteed. You are responsible for maintaining your own backups of
                    your data. We do not provide any sort of compensation for lost or incomplete data in the event that
                    backups do not function properly. We will do our best to ensure complete and accurate backups, but
                    assume no responsibility for this duty.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 4 - LINKS TO OTHER MOBILE APPLICATIONS
                </Text>
                <Text className={'mt-[10px]'}>
                    Although this Mobile Application may link to other mobile applications, we are not, directly or
                    indirectly, implying any approval, association, sponsorship, endorsement, or affiliation with any
                    linked mobile application, unless specifically stated herein. We are not responsible for examining
                    or evaluating, and we do not warrant the offerings of, any businesses or individuals or the content
                    of their mobile applications. We do not assume any responsibility or liability for the actions,
                    products, services, and content of any other third-parties. You should carefully review the legal
                    statements and other conditions of use of any mobile application which you access through a link
                    from this Mobile Application. Your linking to any other off-site mobile applications is at your own
                    risk.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 5 - PERSONAL INFORMATION
                </Text>
                <Text className={'mt-[10px]'}>
                    Your submission of personal information through the Mobile Application is governed by our Privacy
                    Policy.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 6 - ERRORS, INACCURACIES, AND OMISSIONS
                </Text>
                <Text className={'mt-[10px]'}>
                    We undertake no obligation to update, amend or clarify information in the Service or on any related
                    website, including without limitation, pricing information, except as required by law. No specified
                    update or refresh date applied in the Service or on any related website, should be taken to indicate
                    that all information in the Service or on any related website has been modified or updated.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 7 - PROHIBITED USES
                </Text>
                <Text className={'mt-[10px]'}>
                    In addition to other terms as set forth in the Agreement, you are prohibited from using the Mobile
                    Application or its Content: (a) for any unlawful purpose; (b) to solicit others to perform or
                    participate in any unlawful acts; (c) to violate any international, federal, provincial or state
                    regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual
                    property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm,
                    defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation,
                    religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading
                    information; (g) to upload or transmit viruses or any other type of malicious code that will or may
                    be used in any way that will affect the functionality or operation of the Service or of any related
                    mobile application, other mobile applications, or the Internet; (h) to collect or track the personal
                    information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any
                    obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the
                    Service or any related mobile application, other mobile applications, or the Internet. We reserve
                    the right to terminate your use of the Service or any related mobile application for violating any
                    of the prohibited uses.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 8 - INTELLECTUAL PROPERTY RIGHTS
                </Text>
                <Text className={'mt-[10px]'}>
                    This Agreement does not transfer to you any intellectual property owned by Mobile Application or
                    third-parties, and all rights, titles, and interests in and to such property will remain (as between
                    the parties) solely with Mobile Application. All trademarks, service marks, graphics and logos used
                    in connection with our Mobile Application or Services, are trademarks or registered trademarks of
                    Mobile Application or Mobile Application licensors. Other trademarks, service marks, graphics and
                    logos used in connection with our Mobile Application or Services may be the trademarks of other
                    third-parties. Your use of our Mobile Application and Services grants you no right or license to
                    reproduce or otherwise use any Mobile Application or third-party trademarks.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 9 - LIMITATION OF LIABILITY
                </Text>
                <Text className={'mt-[10px]'}>
                    To the fullest extent permitted by applicable law, in no event will Mobile Application, its
                    affiliates, officers, directors, employees, agents, suppliers or licensors be liable to any person
                    for (a): any indirect, incidental, special, punitive, cover or consequential damages (including,
                    without limitation, damages for lost profits, revenue, sales, goodwill, use or content, impact on
                    business, business interruption, loss of anticipated savings, loss of business opportunity) however
                    caused, under any theory of liability, including, without limitation, contract, tort, warranty,
                    breach of statutory duty, negligence or otherwise, even if Mobile Application has been advised as to
                    the possibility of such damages or could have foreseen such damages. To the maximum extent permitted
                    by applicable law, the aggregate liability of Mobile Application and its affiliates, officers,
                    employees, agents, suppliers and licensors, relating to the services will be limited to an amount
                    greater of one dollar or any amounts actually paid in cash by you to Mobile Application for the
                    prior one month period prior to the first event or occurrence giving rise to such liability. The
                    limitations and exclusions also apply if this remedy does not fully compensate you for any losses or
                    fails of its essential purpose.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 10 - INDEMNIFICATION
                </Text>
                <Text className={'mt-[10px]'}>
                    You agree to indemnify and hold Mobile Application and its affiliates, directors, officers,
                    employees, and agents harmless from and against any liabilities, losses, damages or costs, including
                    reasonable attorneys&apos; fees, incurred in connection with or arising from any third-party
                    allegations, claims, actions, disputes, or demands asserted against any of them as a result of or
                    relating to your Content, your use of the Mobile Application or Services or any willful misconduct
                    on your part.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 11 - SEVERABILITY
                </Text>
                <Text className={'mt-[10px]'}>
                    All rights and restrictions contained in this Agreement may be exercised and shall be applicable and
                    binding only to the extent that they do not violate any applicable laws and are intended to be
                    limited to the extent necessary so that they will not render this Agreement illegal, invalid or
                    unenforceable. If any provision or portion of any provision of this Agreement shall be held to be
                    illegal, invalid or unenforceable by a court of competent jurisdiction, it is the intention of the
                    parties that the remaining provisions or portions thereof shall constitute their agreement with
                    respect to the subject matter hereof, and all such remaining provisions or portions thereof shall
                    remain in full force and effect.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>SECTION 12 - TERMINATION</Text>
                <Text className={'mt-[10px]'}>
                    The obligations and liabilities of the parties incurred prior to the termination date shall survive
                    the termination of this agreement for all purposes. These Terms of Service are effective unless and
                    until terminated by either you or us. You may terminate these Terms of Service at any time by
                    notifying us that you no longer wish to use our Services, or when you cease using our Mobile
                    Application. We may terminate or suspend your account immediately, without prior notice or
                    liability, for any reason whatsoever, including without limitation if you breach the Terms. If in
                    our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision
                    of these Terms of Service, we also may terminate this agreement at any time without notice and you
                    will remain liable for all amounts due up to and including the date of termination; and/or
                    accordingly may deny you access to our Services (or any part thereof). All provisions of the Terms
                    which by their nature should survive termination shall survive termination, including, without
                    limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 13 - ENTIRE AGREEMENT
                </Text>
                <Text className={'mt-[10px]'}>
                    The failure of us to exercise or enforce any right or provision of these Terms of Service shall not
                    constitute a waiver of such right or provision.
                    <br />
                    These Terms of Service and any policies or operating rules posted by us or in respect to The Service
                    constitutes the entire agreement and understanding between you and us and govern your use of the
                    Service, superseding any prior or contemporaneous agreements, communications and proposals, whether
                    oral or written, between you and us (including, but not limited to, any prior versions of the Terms
                    of Service).
                    <br />
                    Any ambiguities in the interpretation of these Terms of Service shall not be construed against the
                    drafting party.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 14 - GOVERNING LAW
                </Text>
                <Text className={'mt-[10px]'}>
                    The formation, interpretation, and performance of this Agreement and any disputes arising out of it
                    shall be governed by the substantive and procedural laws of the Republic of Korea without regard to
                    its rules on conflicts or choice of law and, to the extent applicable, the laws of the Republic of
                    Korea. The exclusive jurisdiction and venue for actions related to the subject matter hereof shall
                    be the state and federal courts located in the Republic of Korea, and you hereby submit to the
                    personal jurisdiction of such courts. You hereby waive any right to a jury trial in any proceeding
                    arising out of or related to this Agreement.
                    <br />
                    The United Nations Convention on Contracts for the International Sale of Goods does not apply to
                    this Agreement.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 15 - CHANGES AND AMENDMENTS
                </Text>
                <Text className={'mt-[10px]'}>
                    We reserve the right to modify this Agreement or its policies relating to the Mobile Application or
                    Services at any time, effective upon posting of an updated version of this Agreement in the Mobile
                    Application. When we do, we will revise the updated date at the bottom of this page. Continued use
                    of the Mobile Application after any such changes shall constitute your consent to such changes.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 16 - ACCEPTANCE OF THESE TERMS
                </Text>
                <Text className={' mt-[10px]'}>
                    You acknowledge that you have read this Agreement and agree to its terms and conditions. By using
                    the Mobile Application or its Services you agree to be bound by this Agreement. If you do not agree
                    to abide by the terms of this Agreement, you are not authorized to use or access the Mobile
                    Application and its Services.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 17 - QUESTIONS AND CONTACT INFORMATION
                </Text>
                <Text className={'mt-[10px]'}>
                    If you have any questions about this Agreement, please contact us at:{' '}
                    <a href="mailto:support@leagueoftraders.io">support@leagueoftraders.io</a>. Please include your
                    name, and mailing or email address.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 18 - COMMUNITY POLICIES
                </Text>
                <Text className={'mt-[10px]'}>
                    When you use League of Traders, you join a community of people from all over the world. Every cool,
                    new community feature on League of Traders involves a certain level of trust. Many of users respect
                    that trust and we trust you to be responsible too. Following the guidelines below helps to keep
                    League of Traders fun and enjoyable for everyone.
                </Text>
                <Text className={'mt-[10px]'}>
                    You might not like everything you see on League of Traders. If you think content is inappropriate,
                    use the ‘Report’ feature to submit it for review by our League of Traders staff. Our staff carefully
                    reviews reported content 24 hours a day, 7 days a week to determine whether there’s a violation of
                    our Community Guidelines.
                </Text>
                <Text className={'mt-[10px]'}>Community Guidelines</Text>
                <Text className={'mt-[10px]'}>
                    Here are some common-sense rules that&apos;ll help you steer clear of trouble. Please take these
                    rules seriously and take them to heart. Don&apos;t try to look for loopholes or try to lawyer your
                    way around the guidelines—just understand them and try to respect the spirit in which they were
                    created.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text>
                        <strong>Nudity or sexual content</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        League of Traders is not for pornography or sexually explicit content. If this describes your
                        post, even if it&apos;s a post of yourself, don&apos;t post it on League of Traders. Also, be
                        advised that we work closely with law enforcement and we report child exploitation.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Harmful or dangerous content</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        Don&apos;t post posts that encourage others to do things that might cause them to get badly
                        hurt, especially kids. posts showing such harmful or dangerous acts may get age-restricted or
                        removed depending on their severity.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Hateful content</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        Our products are platforms for free expression. But we don&apos;t support content that promotes
                        or condones violence against individuals or groups based on race or ethnic origin, religion,
                        disability, gender, age, nationality, veteran status, caste, sexual orientation, or gender
                        identity, or content that incites hatred on the basis of these core characteristics.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Violent or graphic content</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        It&apos;s not okay to post violent or gory content that&apos;s primarily intended to be
                        shocking, sensational, or gratuitous. If posting graphic content in a news or documentary
                        context, please be mindful to provide enough information to help people understand what&apos;s
                        going on in the post. Don&apos;t encourage others to commit specific acts of violence.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Harassment and cyberbullying</strong>
                    </Text>
                    <Text className={' mt-[10px]'}>
                        It’s not ok to post abusive posts and comments on League of Traders. If harassment crosses the
                        line into a malicious attack it can be reported and may be removed. In other cases, users may be
                        mildly annoying or petty and should be ignored.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Spam, misleading metadata, and scams</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        Everyone hates spam. Don&apos;t create misleading descriptions, tags, titles, or thumbnails in
                        order to increase views. It&apos;s not okay to post large amounts of untargeted, unwanted or
                        repetitive content, including comments and private messages.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Threats</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        Things like predatory behavior, stalking, threats, harassment, intimidation, invading privacy,
                        revealing other people&apos;s personal information, and inciting others to commit violent acts
                        or to violate the Terms of Use are taken very seriously. Anyone caught doing these things may be
                        permanently banned from League of Traders.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Copyright</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        Respect copyright. Only upload posts that you made or that you&apos;re authorized to use. This
                        means don&apos;t upload posts you didn&apos;t make, or use content in your posts that someone
                        else owns the copyright to, such as music tracks, snippets of copyrighted programs, or posts
                        made by other users, without necessary authorizations. Visit our Copyright Center for more
                        information.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Privacy</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        If someone has posted your personal information or uploaded a post of you without your consent,
                        you can request removal of content based on our Privacy Guidelines.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Impersonation</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        Accounts that are established to impersonate another channel or individual may be removed under
                        our impersonation policy.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Child Safety</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>
                        Learn about how we protect minors in the League of Traders ecosystem. Also, be advised that we
                        work closely with law enforcement and we report child endangerment.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Additional policies</strong>
                    </Text>
                    <Text className={'mt-[10px]'}>Additional policies on a range of subjects.</Text>
                </div>
                <Text className={'mt-[10px]'}>
                    If a League of Traders trader’s on- and/or off-platform behavior harms our users, community,
                    employees or ecosystem, we may respond based on a number of factors including, but not limited to,
                    the egregiousness of their actions and whether a pattern of harmful behavior exists.
                </Text>
                <Text className={'mt-[10px]'}>
                    Our response will range from suspending a trader’s privileges to account termination.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 19 - RECEIVING ADVERTISING INFORMATION
                </Text>
                <Text className={'mt-[10px]'}>
                    1.Advertising information, such as customized service, gift events, and events provided by League of
                    Traders, is provided to users through e-mail, correspondence, text (SMS) or Kakao Notification Talk,
                    push or phone.
                    <br />
                    2.Whether you agree to receive advertising information can be changed from the settings of the
                    League of Traders service.
                </Text>
            </div>
        </>
    )
}
